// extracted by mini-css-extract-plugin
export default {"item":"_UznTUgoIvoB3GlDw6w6"};